export const STORAGE_FEATURES = {
  moduleKey: 'storage',
  features: ['storage.files', 'storage.blob'] as const,
  featureMeta: {
    'storage.files': {
      name: 'File storage',
      translations: { name: { de: 'Dateispeicher', en: 'File storage', fr: 'Stockage de fichiers', it: 'Archiviazione file' } },
    },
    'storage.blob': {
      name: 'Blob storage',
      translations: { name: { de: 'Blob-Speicher', en: 'Blob storage', fr: 'Stockage Blob', it: 'Archiviazione Blob' } },
    },
  },
} as const;
